import { gsap as f } from "../../node_modules/gsap/index.js";
import { defineQuery as B } from "bitecs";
import "../../core/ecs/components.js";
import { toCamelCase as $ } from "../../core/utils/naming.js";
import "three";
import "../../core/validation/schemas.js";
import { Body as m, BodyType as Z } from "../physics/components.js";
import "../physics/recipes.js";
import "../physics/systems.js";
import "../physics/utils.js";
import { Transform as K } from "../transforms/components.js";
import "../transforms/systems.js";
import { TweenValue as d, TransformShakerAxes as h, TransformShakerType as x, Sequence as I, SequenceState as T, Shaker as C, ShakerMode as V, TransformShaker as S, Tween as R, KinematicTween as y, KinematicRotationTween as E } from "./components.js";
const F = {
  linear: "linear",
  "sine-in": "sineIn",
  "sine-out": "sineOut",
  "sine-in-out": "sineInOut",
  "quad-in": "quadIn",
  "quad-out": "quadOut",
  "quad-in-out": "quadInOut",
  "cubic-in": "cubicIn",
  "cubic-out": "cubicOut",
  "cubic-in-out": "cubicInOut",
  "quart-in": "quartIn",
  "quart-out": "quartOut",
  "quart-in-out": "quartInOut",
  "expo-in": "expoIn",
  "expo-out": "expoOut",
  "expo-in-out": "expoInOut",
  "circ-in": "circIn",
  "circ-out": "circOut",
  "circ-in-out": "circInOut",
  "back-in": "backIn",
  "back-out": "backOut",
  "back-in-out": "backInOut",
  "elastic-in": "elasticIn",
  "elastic-out": "elasticOut",
  "elastic-in-out": "elasticInOut",
  "bounce-in": "bounceIn",
  "bounce-out": "bounceOut",
  "bounce-in-out": "bounceInOut"
}, A = {
  linear: (e) => e,
  sineIn: (e) => f.parseEase("power1.in")(e),
  sineOut: (e) => f.parseEase("power1.out")(e),
  sineInOut: (e) => f.parseEase("power1.inOut")(e),
  quadIn: (e) => f.parseEase("power2.in")(e),
  quadOut: (e) => f.parseEase("power2.out")(e),
  quadInOut: (e) => f.parseEase("power2.inOut")(e),
  cubicIn: (e) => f.parseEase("power3.in")(e),
  cubicOut: (e) => f.parseEase("power3.out")(e),
  cubicInOut: (e) => f.parseEase("power3.inOut")(e),
  quartIn: (e) => f.parseEase("power4.in")(e),
  quartOut: (e) => f.parseEase("power4.out")(e),
  quartInOut: (e) => f.parseEase("power4.inOut")(e),
  expoIn: (e) => f.parseEase("expo.in")(e),
  expoOut: (e) => f.parseEase("expo.out")(e),
  expoInOut: (e) => f.parseEase("expo.inOut")(e),
  circIn: (e) => f.parseEase("circ.in")(e),
  circOut: (e) => f.parseEase("circ.out")(e),
  circInOut: (e) => f.parseEase("circ.inOut")(e),
  backIn: (e) => f.parseEase("back.in")(e),
  backOut: (e) => f.parseEase("back.out")(e),
  backInOut: (e) => f.parseEase("back.inOut")(e),
  elasticIn: (e) => f.parseEase("elastic.in")(e),
  elasticOut: (e) => f.parseEase("elastic.out")(e),
  elasticInOut: (e) => f.parseEase("elastic.inOut")(e),
  bounceIn: (e) => f.parseEase("bounce.in")(e),
  bounceOut: (e) => f.parseEase("bounce.out")(e),
  bounceInOut: (e) => f.parseEase("bounce.inOut")(e)
};
function fe(e, r) {
  const a = A[r];
  return a ? a(e) : (console.warn(`Unknown easing key "${r}", falling back to linear`), A.linear(e));
}
function w(e) {
  return e * (Math.PI / 180);
}
function b(e, r, a) {
  const [n, t] = e.split(".");
  if (!n || !t) return null;
  let l = n;
  if (n === "shaker") {
    const p = a.getComponent("transform-shaker");
    p && a.hasComponent(r, p) && (l = "transform-shaker");
  }
  const s = a.getComponent(l);
  if (!s || !a.hasComponent(r, s)) return null;
  const o = $(t), u = s[o];
  return u instanceof Float32Array ? { component: s, field: o, array: u } : null;
}
function q(e, r) {
  return e === void 0 ? Array.isArray(r) ? r : [r] : Array.isArray(e) ? e : [e];
}
function M(e, r, a, n) {
  const t = [];
  if (e === "rotation") {
    const l = q(r.to, [0, 0, 0]), s = ["eulerX", "eulerY", "eulerZ"], u = n.hasComponent(a, m) ? "body" : "transform";
    for (let p = 0; p < s.length; p++) {
      const g = b(
        `${u}.${s[p]}`,
        a,
        n
      ), k = g ? g.array[a] : 0, i = r.from !== void 0 ? q(r.from, [0, 0, 0])[p] ?? k : k;
      t.push({
        field: `${u}.${s[p]}`,
        from: i,
        to: l[p] || 0
      });
    }
  } else if (e === "at") {
    const l = q(r.to, [0, 0, 0]), s = ["posX", "posY", "posZ"];
    for (let o = 0; o < s.length; o++) {
      const u = b(
        `transform.${s[o]}`,
        a,
        n
      ), p = u ? u.array[a] : 0, g = r.from !== void 0 ? q(r.from, [0, 0, 0])[o] ?? p : p;
      t.push({
        field: `transform.${s[o]}`,
        from: g,
        to: l[o] || 0
      });
    }
  } else if (e === "scale") {
    const l = q(r.to, [1, 1, 1]), s = ["scaleX", "scaleY", "scaleZ"];
    for (let o = 0; o < s.length; o++) {
      const u = b(
        `transform.${s[o]}`,
        a,
        n
      ), p = u ? u.array[a] : 1, g = r.from !== void 0 ? q(r.from, [1, 1, 1])[o] ?? p : p;
      t.push({
        field: `transform.${s[o]}`,
        from: g,
        to: l[o] ?? 1
      });
    }
  }
  return t;
}
const N = Object.values(F), P = /* @__PURE__ */ new Map();
N.forEach((e, r) => P.set(e, r));
const Y = /* @__PURE__ */ new Map(), z = /* @__PURE__ */ new Map(), X = /* @__PURE__ */ new Map(), D = /* @__PURE__ */ new Map(), pe = /* @__PURE__ */ new Map(), me = /* @__PURE__ */ new Map(), de = /* @__PURE__ */ new Map();
function ye(e, r) {
  e.hasComponent(r, I) && (I.state[r] = T.Playing);
}
function Q(e, r) {
  if (!e.hasComponent(r, I)) return;
  I.state[r] = T.Idle;
  const a = X.get(r);
  if (a) {
    for (const n of a)
      e.exists(n) && e.destroyEntity(n);
    a.clear();
  }
}
function Ee(e, r) {
  Q(e, r), I.currentIndex[r] = 0, I.pauseRemaining[r] = 0;
}
function ge(e, r) {
  if (!e.hasComponent(r, I) || I.state[r] !== T.Playing) return;
  const a = X.get(r);
  if (a) {
    for (const t of a)
      G(e, t), e.exists(t) && e.destroyEntity(t);
    a.clear();
  }
  const n = z.get(r);
  if (n) {
    const t = I.currentIndex[r];
    for (let l = t; l < n.length; l++) {
      const s = n[l];
      s.type === "tween" && s.target !== void 0 && s.attr && U(e, s.target, s.attr, s.to ?? 0);
    }
  }
  I.state[r] = T.Idle, I.currentIndex[r] = 0, I.pauseRemaining[r] = 0;
}
const j = B([d]);
function G(e, r) {
  const a = [];
  for (const n of j(e.world)) {
    if (d.source[n] !== r) continue;
    const t = d.target[n], l = Y.get(n);
    l && t < l.length && (l[t] = d.to[n]), Y.delete(n), a.push(n);
  }
  for (const n of a)
    e.destroyEntity(n);
}
function U(e, r, a, n) {
  const t = M(a, { to: n }, r, e);
  if (t.length > 0)
    for (const l of t) {
      const s = b(l.field, r, e);
      s && (s.array[r] = l.to);
    }
  else {
    const l = b(a, r, e);
    l && (l.array[r] = typeof n == "number" ? n : n[0]);
  }
}
function he(e, r, a, n) {
  const t = e.createEntity();
  e.addComponent(t, R), R.duration[t] = n.duration ?? 1, R.elapsed[t] = 0;
  const l = n.easing ? F[n.easing] || n.easing : "linear";
  R.easingIndex[t] = P.get(l) ?? 0;
  const s = M(a, n, r, e);
  if (s.length > 0)
    for (const o of s) {
      const u = b(o.field, r, e);
      if (!u) continue;
      const p = e.hasComponent(r, m) && m.type[r] === Z.KinematicVelocityBased, g = u.array === m.posX || u.array === m.posY || u.array === m.posZ, k = u.array === m.eulerX || u.array === m.eulerY || u.array === m.eulerZ;
      if (p && g) {
        const i = e.createEntity();
        e.addComponent(i, y);
        let O = 0;
        u.array === m.posY ? O = 1 : u.array === m.posZ && (O = 2);
        const c = u.array[r];
        y.tweenEntity[i] = t, y.targetEntity[i] = r, y.axis[i] = O, y.from[i] = o.from, y.to[i] = o.to, y.lastPosition[i] = c, y.targetPosition[i] = o.from;
      } else if (p && k) {
        const i = e.createEntity();
        e.addComponent(i, E);
        let O = 0;
        u.array === m.eulerY ? O = 1 : u.array === m.eulerZ && (O = 2);
        const c = u.array[r];
        E.tweenEntity[i] = t, E.targetEntity[i] = r, E.axis[i] = O, E.from[i] = w(
          o.from
        ), E.to[i] = w(
          o.to
        ), E.lastRotation[i] = w(c), E.targetRotation[i] = w(o.from);
      } else {
        const i = e.createEntity();
        e.addComponent(i, d), d.source[i] = t, d.target[i] = r, d.componentId[i] = 0, d.fieldIndex[i] = 0, d.from[i] = o.from, d.to[i] = o.to, d.value[i] = o.from, Y.set(i, u.array);
      }
    }
  else {
    const o = b(a, r, e);
    if (!o) return null;
    const u = o.array[r], p = typeof n.from == "number" ? n.from : n.from?.[0] ?? u, g = typeof n.to == "number" ? n.to : n.to[0], k = e.hasComponent(r, m) && m.type[r] === Z.KinematicVelocityBased, i = o.array === m.posX || o.array === m.posY || o.array === m.posZ, O = o.array === m.eulerX || o.array === m.eulerY || o.array === m.eulerZ;
    if (k && i) {
      const c = e.createEntity();
      e.addComponent(c, y);
      let v = 0;
      o.array === m.posY ? v = 1 : o.array === m.posZ && (v = 2), y.tweenEntity[c] = t, y.targetEntity[c] = r, y.axis[c] = v, y.from[c] = p, y.to[c] = g, y.lastPosition[c] = u, y.targetPosition[c] = p;
    } else if (k && O) {
      const c = e.createEntity();
      e.addComponent(c, E);
      let v = 0;
      o.array === m.eulerY ? v = 1 : o.array === m.eulerZ && (v = 2), E.tweenEntity[c] = t, E.targetEntity[c] = r, E.axis[c] = v, E.from[c] = w(p), E.to[c] = w(g), E.lastRotation[c] = w(u), E.targetRotation[c] = w(p);
    } else {
      const c = e.createEntity();
      e.addComponent(c, d), d.source[c] = t, d.target[c] = r, d.componentId[c] = 0, d.fieldIndex[c] = 0, d.from[c] = p, d.to[c] = g, d.value[c] = p, Y.set(c, o.array);
    }
  }
  return t;
}
const W = {
  // Position single-axis
  "transform.pos-x": {
    type: x.Position,
    axes: h.X
  },
  "transform.pos-y": {
    type: x.Position,
    axes: h.Y
  },
  "transform.pos-z": {
    type: x.Position,
    axes: h.Z
  },
  // Scale single-axis
  "transform.scale-x": {
    type: x.Scale,
    axes: h.X
  },
  "transform.scale-y": {
    type: x.Scale,
    axes: h.Y
  },
  "transform.scale-z": {
    type: x.Scale,
    axes: h.Z
  },
  // Rotation single-axis
  "transform.euler-x": {
    type: x.Rotation,
    axes: h.X
  },
  "transform.euler-y": {
    type: x.Rotation,
    axes: h.Y
  },
  "transform.euler-z": {
    type: x.Rotation,
    axes: h.Z
  },
  // Shorthands (all axes)
  at: { type: x.Position, axes: h.XYZ },
  scale: { type: x.Scale, axes: h.XYZ },
  rotation: {
    type: x.Rotation,
    axes: h.XYZ
  }
};
function _(e) {
  return W[e] ?? null;
}
function H(e, r, a, n) {
  if (!e.hasComponent(r, K))
    return console.warn("[TransformShaker] Entity must have Transform component"), null;
  const t = e.createEntity();
  return e.addComponent(t, S), S.target[t] = r, S.type[t] = a.type, S.axes[t] = a.axes, S.value[t] = n.value, S.intensity[t] = n.intensity ?? 1, S.mode[t] = n.mode === "multiplicative" ? V.Multiplicative : V.Additive, t;
}
function xe(e, r, a, n) {
  const t = _(a);
  if (t)
    return H(e, r, t, n);
  const l = b(a, r, e);
  if (!l)
    return console.warn(`[Shaker] Could not resolve target property: ${a}`), null;
  const s = e.createEntity();
  return e.addComponent(s, C), C.target[s] = r, C.value[s] = n.value, C.intensity[s] = n.intensity ?? 1, C.mode[s] = n.mode === "multiplicative" ? V.Multiplicative : V.Additive, D.set(s, l.array), s;
}
export {
  F as EasingNames,
  fe as applyEasing,
  ge as completeSequence,
  xe as createShaker,
  H as createTransformShaker,
  he as createTween,
  w as degreesToRadians,
  M as expandShorthand,
  _ as parseTransformTarget,
  ye as playSequence,
  Ee as resetSequence,
  b as resolveComponentField,
  X as sequenceActiveTweens,
  z as sequenceRegistry,
  pe as shakerBaseRegistry,
  D as shakerFieldRegistry,
  Q as stopSequence,
  me as transformShakerBaseRegistry,
  de as transformShakerQuatRegistry,
  Y as tweenFieldRegistry
};
//# sourceMappingURL=utils.js.map
